var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 26,
    viewBox: "0 0 26 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_186_1918)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13 25.9995C20.1797 25.9995 26 20.1792 26 12.9995C26 5.81981 20.1797 -0.000488281 13 -0.000488281C5.8203 -0.000488281 0 5.81981 0 12.9995C0 20.1792 5.8203 25.9995 13 25.9995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.7677 14.046V19.4056H17.6603V14.4052C17.6603 13.1496 17.2116 12.2922 16.0866 12.2922C15.228 12.2922 14.7179 12.8695 14.4927 13.4284C14.4109 13.6282 14.3898 13.9056 14.3898 14.1857V19.4054H11.2822C11.2822 19.4054 11.3239 10.9363 11.2822 10.0597H14.39V11.384C14.3838 11.3945 14.3749 11.4047 14.3694 11.4146H14.39V11.384C14.803 10.7486 15.5394 9.84021 17.1906 9.84021C19.2349 9.84021 20.7677 11.1759 20.7677 14.046ZM8.03137 5.55469C6.96839 5.55469 6.27295 6.25245 6.27295 7.1692C6.27295 8.06649 6.94823 8.78441 7.99059 8.78441H8.01075C9.09458 8.78441 9.76847 8.06649 9.76847 7.1692C9.74785 6.25245 9.09458 5.55469 8.03137 5.55469ZM6.45764 19.4056H9.56408V10.0597H6.45764V19.4056Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_186_1918"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 26,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.3b8eb189e816dae26439d84983c6c82c.svg";
export { ForwardRef as ReactComponent };